export default __webpack_public_path__ + "1ded3f0.png";